import { render } from "./AddLanguageModal.vue?vue&type=template&id=337ed163&scoped=true"
import script from "./AddLanguageModal.vue?vue&type=script&lang=js"
export * from "./AddLanguageModal.vue?vue&type=script&lang=js"

import "../pages/languagePackage/language-package.scss?vue&type=style&index=0&id=337ed163&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337ed163"]])

export default __exports__